import { OAuth } from "../component/OAuth"

export const UserPage=()=>{
    return (<OAuth/>);
}